import React from "react";
import { Bot, User as UserIcon } from "lucide-react";

interface ChatBubbleProps {
  role: "user" | "assistant";
  text: string;
}

const ChatBubble: React.FC<ChatBubbleProps> = ({ role, text }) => {
  const isUser = role === "user";
  return (
    <div className={`w-full flex ${isUser ? "justify-end" : "justify-start"}`}>
      <div
        className={`max-w-[85%] md:max-w-[70%] rounded-2xl p-3 shadow-sm border ${
          isUser
            ? "bg-teal-600 text-white rounded-br-sm"
            : "bg-white text-gray-800 rounded-bl-sm border-gray-200"
        }`}
      >
        <div className="flex items-start gap-2">
          {!isUser && <Bot size={18} className="text-teal-600 mt-0.5" />}
          <p className="leading-relaxed whitespace-pre-wrap">{text}</p>
          {isUser && <UserIcon size={18} className="mt-0.5 ml-1 opacity-90" />}
        </div>
      </div>
    </div>
  );
};

export default ChatBubble;
